(function(){
  var root = document.querySelector('[data-ubp]');
  if(!root || root.dataset.init) return; root.dataset.init = '1';

  var BOOKS = [];
  try { BOOKS = JSON.parse(root.querySelector('[data-ubp-pool]').textContent) || []; } catch(e){}
  if(!BOOKS.length){ root.style.display = 'none'; return; }
  var THIN = BOOKS.length < 2;   // no partners -> 1x only, but STILL render + tag

  var MAIN = 0;
  var CMP  = +root.dataset.cmp;
  var PRE  = root.dataset.codePrefix || 'BUNDLE';
  var LOC  = root.dataset.codeLocale || '';
  var TIERS_ALL = [
    { qty:1, pct:0,                    popular:false, ship:false },
    { qty:2, pct:+root.dataset.pct2||0, popular:true,  ship:true  },
    { qty:3, pct:+root.dataset.pct3||0, popular:false, ship:true  }
  ];
  var TIERS = THIN ? TIERS_ALL.slice(0, 1) : TIERS_ALL;
  var state = { tier:0, picks:{2:MAIN, 3:MAIN} };
  var BASE = BOOKS[MAIN].p;

  // Books are not all the same price, so totals are computed from the ACTUAL
  // selection rather than assumed to be main-price x qty.
  function picksFor(qty){
    var out = [BOOKS[MAIN]];
    for(var n = 2; n <= qty; n++) out.push(BOOKS[state.picks[n]] || BOOKS[MAIN]);
    return out;
  }
  function sums(T, useActual){
    var gross = 0, cmp = 0;
    if(useActual){
      picksFor(T.qty).forEach(function(b){ gross += b.p; cmp += (b.c || b.p); });
    } else {
      gross = BASE * T.qty; cmp = (BOOKS[MAIN].c || BASE) * T.qty;
    }
    var total = Math.round(gross * (100 - T.pct) / 100);
    return { gross: gross, cmp: cmp, total: total, unit: Math.round(total / T.qty) };
  }

  function money(cents){
    var n = Math.round(cents / 100);
    return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, '\u002e') + 'Ft';
  }
  function szo(){ return 'könyv'; }
  function pct(u, of){ return Math.round((1 - u / of) * 100); }
  function el(tag, cls, html){
    var n = document.createElement(tag);
    if(cls) n.className = cls;
    if(html != null) n.innerHTML = html;
    return n;
  }
  function cover(b, small){
    var box = el('div', 'ubp__cover' + (small ? ' sm' : ''));
    if(b.img){
      var im = document.createElement('img');
      im.src = b.img; im.alt = ''; im.width = 200; im.height = 200;
      im.loading = 'lazy'; im.decoding = 'async';
      im.onerror = function(){ im.remove(); };
      box.appendChild(im);
    }
    return box;
  }

  var tiersEl  = root.querySelector('.ubp__tiers');
  var nowEl    = root.querySelector('[data-ubp-now]');
  var wasEl    = root.querySelector('[data-ubp-was]');
  var offEl    = root.querySelector('[data-ubp-off]');
  var labelEl  = root.querySelector('[data-ubp-label]');
  var ctaEl    = root.querySelector('[data-ubp-cta]');
  var statusEl = root.querySelector('[data-ubp-status]');

  function slotFor(n){
    var wrap = el('div', 'ubp__slot');
    var lab = el('p', 'ubp__lab', 'KÖNYV #' + n);
    lab.appendChild(el('span', 'h', 'válassz alább'));
    wrap.appendChild(lab);
    var grid = el('div', 'ubp__grid');
    grid.setAttribute('role', 'radiogroup');
    grid.setAttribute('aria-label', 'Könyv ' + n);
    BOOKS.forEach(function(b, bi){
      var p = el('button', 'ubp__pick');
      p.type = 'button';
      p.setAttribute('role', 'radio');
      p.setAttribute('aria-checked', state.picks[n] === bi ? 'true' : 'false');
      p.appendChild(el('div', 'ubp__tick', '\u2713'));
      p.appendChild(cover(b, false));
      p.appendChild(el('span', null, b.t));
      p.addEventListener('click', function(){ state.picks[n] = bi; render(); });
      grid.appendChild(p);
    });
    wrap.appendChild(grid);
    return wrap;
  }

  function syncSticky(T){
    var box = document.querySelector('.prod__sticky-atc');
    if(!box) return;
    var cur = box.querySelector('.sticky-price-current');
    var was = box.querySelector('.sticky-price-compare');
    var txt = box.querySelector('.atc-text');
    var S = sums(T, true);
    if(cur) cur.textContent = money(S.total);
    if(was) was.textContent = money(S.cmp);
    if(txt) txt.textContent = 'Kosárba teszem';
  }

  function render(){
    tiersEl.innerHTML = '';
    TIERS.forEach(function(T, ti){
      var on = state.tier === ti;
      var card = el('div', 'ubp__tier');
      card.setAttribute('data-on', on ? '1' : '0');
      if(T.popular) card.appendChild(el('div', 'ubp__flag', 'LEGNÉPSZERŰBB'));

      var btn = el('button', 'ubp__btn');
      btn.type = 'button';
      btn.setAttribute('role', 'radio');
      btn.setAttribute('aria-checked', on ? 'true' : 'false');

      var S = sums(T, on);
      var top = el('div', 'ubp__top');
      var radio = el('div', 'ubp__radio'); radio.appendChild(el('i'));
      top.appendChild(radio);
      top.appendChild(el('div', 'ubp__name', T.qty + '\u00D7 ' + szo()));
      top.appendChild(el('div', 'ubp__price',
        '<b>' + money(S.unit) + '</b> <span>/ db</span> <s>' + money(Math.round(S.cmp / T.qty)) + '</s>'));
      btn.appendChild(top);

      if(ti > 0){
        var save = S.gross - S.total;
        var meta = el('div', 'ubp__meta');
        meta.appendChild(el('span', 's',
          '\u2212' + T.pct + '\u00A0% \u00B7 Megtakarítás ' + money(save)));
        if(T.ship) meta.appendChild(el('span', 'sh', '\uD83D\uDE9A Ingyenes szállítás'));
        btn.appendChild(meta);
      }
      btn.addEventListener('click', function(){ state.tier = ti; render(); });
      card.appendChild(btn);

      if(T.qty > 1){
        var slots = el('div', 'ubp__slots');
        var s1 = el('div', 'ubp__slot');
        s1.appendChild(el('p', 'ubp__lab', 'KÖNYV #1'));
        var fixed = el('div', 'ubp__fixed');
        fixed.appendChild(cover(BOOKS[MAIN], true));
        fixed.appendChild(el('p', null, BOOKS[MAIN].t));
        s1.appendChild(fixed);
        slots.appendChild(s1);
        for(var n = 2; n <= T.qty; n++) slots.appendChild(slotFor(n));
        card.appendChild(slots);
      }
      tiersEl.appendChild(card);
    });

    var T = TIERS[state.tier], S = sums(T, true);
    nowEl.textContent = money(S.total);
    wasEl.textContent = money(S.cmp);
    offEl.textContent = '\u2212' + Math.round((1 - S.total / S.cmp) * 100) + '\u00A0%';
    labelEl.textContent = 'Kosárba teszem';
    syncSticky(T);
  }

  function say(t, err){
    statusEl.textContent = t || '';
    statusEl.className = 'ubp__status' + (err ? ' ubp__status--err' : '');
  }
  function drawerEl(){ return document.querySelector('m-cart-drawer'); }

  // /cart/update.js accepts `discount` since May 2025.
  function codesFor(qty){
    if(qty < 2 || !LOC) return '';
    return PRE + qty + '_' + LOC + ',' + PRE + qty + '_' + LOC + '_SHIP';
  }
  function applyCartState(qty){
    // /cart/update.js REPLACES the whole code set, so sending only ours wiped
    // any abandonment / email code the customer arrived with. Read the cart
    // first and keep everything that is not one of ours.
    return fetch('/cart.js', { headers:{ 'Accept':'application/json' } })
      .then(function(r){ return r.json(); })
      .then(function(c){
        var mine = {};
        [2, 3].forEach(function(q){
          mine[(PRE + q + '_' + LOC).toUpperCase()] = 1;
          mine[(PRE + q + '_' + LOC + '_SHIP').toUpperCase()] = 1;
        });
        var keep = (c.discount_codes || [])
          .map(function(x){ return x.code; })
          .filter(function(code){ return code && !mine[String(code).toUpperCase()]; });
        var ours = codesFor(qty);
        var all = (ours ? ours.split(',') : []).concat(keep).slice(0, 5);
        return fetch('/cart/update.js', {
          method:'POST',
          headers:{ 'Content-Type':'application/json', 'Accept':'application/json' },
          body: JSON.stringify({
            discount: all.join(','),
            attributes: { bundle_tier: String(qty), bundle_pdf: (root.dataset.pdf || '') },
            sections: 'cart-drawer',
            sections_url: window.location.pathname
          })
        });
      })
      .then(function(r){ return r && r.ok ? r.json() : null; })
      .catch(function(){ return null; });
  }

  function refreshCart(){
    return fetch('/cart.js', { headers:{ 'Accept':'application/json' } })
      .then(function(r){ return r.json(); })
      .then(function(c){
        var d = drawerEl();
        if(d && typeof d.updateCartCount === 'function') d.updateCartCount(c.item_count);
        document.querySelectorAll('.m-cart-count-bubble,[data-cart-count],.cart-count')
          .forEach(function(n){ n.textContent = c.item_count; });
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        document.dispatchEvent(new CustomEvent('cart:updated', { detail:{ cart:c } }));
      }).catch(function(){});
  }

  function addBundle(){
    if(root.classList.contains('is-busy')) return;
    var T = TIERS[state.tier];
    var bid = Date.now().toString(36) + Math.random().toString(36).slice(2, 7);
    var props = { '_bundle':'BUNDLE' + T.qty, '_bundle_id': bid, '_tier': String(T.qty) };
    var items = [{ id: BOOKS[MAIN].id, quantity: 1, properties: props }];
    for(var n = 2; n <= T.qty; n++){
      items.push({ id: BOOKS[state.picks[n]].id, quantity: 1, properties: props });
    }
    root.classList.add('is-busy'); say('Hozzáadás…');
    // The picker SETS the bundle, it does not append. Without this, 1x then 3x
    // leaves four books in the cart (seen live: HU#5783).
    return fetch('/cart.js', { headers:{ 'Accept':'application/json' } })
    .then(function(r){ return r.json(); })
    .then(function(c){
      var upd = {};
      (c.items || []).forEach(function(i){ if(i.properties && i.properties._bundle) upd[i.key] = 0; });
      if(!Object.keys(upd).length) return null;
      return fetch('/cart/update.js', {
        method:'POST',
        headers:{ 'Content-Type':'application/json', 'Accept':'application/json' },
        body: JSON.stringify({ updates: upd })
      });
    })
    .then(function(){
      return fetch('/cart/add.js', {
        method:'POST',
        headers:{ 'Content-Type':'application/json', 'Accept':'application/json' },
        body: JSON.stringify({ items: items })
      });
    })
    .then(function(r){ if(!r.ok) throw 0; return r.json(); })
    .then(function(){
      say('');
      if(window.Shopify && Shopify.analytics && Shopify.analytics.publish){
        Shopify.analytics.publish('bundle_added', {
          tier: T.qty, unit: sums(T, true).unit, total: sums(T, true).total,
          variants: items.map(function(i){ return i.id; })
        });
      }
      // discount + attribute + re-render in ONE call, so the drawer paints
      // the already-discounted totals rather than a stale full price
      return applyCartState(T.qty).then(function(res){
        var d = drawerEl();
        if(!d){ window.location.href = '/cart'; return; }

        // repaint and open are isolated: renderContents throws when the drawer
        // was empty (its target nodes are not in the DOM yet), and that used to
        // swallow open() and surface a false error.
        try {
          if(res && res.sections && typeof d.renderContents === 'function'){
            d.renderContents(res);
          } else if(typeof d.onCartDrawerUpdate === 'function'){
            d.onCartDrawerUpdate();
          }
        } catch(e){
          try { if(typeof d.onCartDrawerUpdate === 'function') d.onCartDrawerUpdate(); } catch(e2){}
        }
        try { if(typeof d.open === 'function') d.open(); } catch(e){}

        // last resort: if nothing put the drawer on screen, go to /cart
        setTimeout(function(){
          if(!d.classList.contains('m-cart-drawer--active')) window.location.href = '/cart';
        }, 800);

        return refreshCart();
      });
    })
    .catch(function(){ say('Hiba, próbáld újra', true); })
    .then(function(){ root.classList.remove('is-busy'); });
  }

  ctaEl.addEventListener('click', addBundle);

  function hijackSticky(){
    var box = document.querySelector('.prod__sticky-atc');
    if(!box || box.dataset.ubpBound) return;
    box.dataset.ubpBound = '1';

    var form = box.querySelector('form.sticky-atc-form, form[data-type="add-to-cart-form"]');
    var btn  = box.querySelector('button.add-to-cart');
    function take(e){
      e.preventDefault();
      e.stopImmediatePropagation();
      addBundle();
      return false;
    }
    if(form) form.addEventListener('submit', take, true);
    if(btn)  btn.addEventListener('click', take, true);

    // hide the sticky bar while the picker itself is on screen
    if('IntersectionObserver' in window){
      new IntersectionObserver(function(entries){
        entries.forEach(function(en){
          box.classList.toggle('ubp-hide', en.isIntersecting);
        });
      }, { threshold: 0, rootMargin: '0px 0px -56px 0px' }).observe(root);
    }

    syncSticky(TIERS[state.tier]);
  }

  // any theme add-to-cart that is still on the page must not produce an
  // untagged order - route it through the picker instead
  function hijackThemeAtc(){
    document.querySelectorAll('form[action*="/cart/add"]').forEach(function(f){
      if(f.dataset.ubpBound || root.contains(f)) return;
      if(f.closest('.prod__sticky-atc')) return;   // handled by hijackSticky
      f.dataset.ubpBound = '1';
      f.addEventListener('submit', function(e){
        e.preventDefault(); e.stopImmediatePropagation();
        addBundle();
        return false;
      }, true);
    });
  }

  render();
  hijackSticky();
  hijackThemeAtc();
  document.addEventListener('DOMContentLoaded', function(){ hijackSticky(); hijackThemeAtc(); });
  window.addEventListener('load', function(){ hijackSticky(); hijackThemeAtc(); });
})();